import { render, staticRenderFns } from "./mail-detail.vue?vue&type=template&id=772f3638&scoped=true&"
import script from "./mail-detail.vue?vue&type=script&lang=js&"
export * from "./mail-detail.vue?vue&type=script&lang=js&"
import style0 from "./mail-detail.vue?vue&type=style&index=0&id=772f3638&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f3638",
  null
  
)

export default component.exports